import React, { Component } from 'react';
import '../styles/floating-video.css'

class FloatingVideo extends Component {
    state = { hide: false }

    constructor(props) {
        super(props)
        this.closeVideo = this.closeVideo.bind(this)
    }

    closeVideo() {
        this.setState({ hide: true })
    }

    render() {
        return (
            <>
                {!this.state.hide && <div className="floating-video" >
                    <div className="floating-video-close-button" onClick={this.closeVideo}></div>
                    <p className="floating-video-text">{this.props.title}:</p>
                    <iframe className="floating-video-stuck" src={this.props.source} title={this.props.title} frameBorder="0" webkitallowfullscreen="" mozallowfullscreen="" allowFullScreen></iframe>
                </div >}
            </>
        );
    }
}

export default FloatingVideo;